module.exports = __webpack_public_path__ + "static/media/FEDEX_TEMPLATE.cffba009.xlsx";